module.exports = __webpack_public_path__ + "static/media/Item 18.15c87d52.jpg";